import { useState, useCallback } from 'react';

export const useToggle = (initialState) => {
  const [state, setState] = useState(initialState);

  const toggle = useCallback(
    (newState = null) =>
      setState((state) => {
        return newState !== null && typeof newState === 'boolean'
          ? newState
          : !state;
      }),
    []
  );

  return [state, toggle];
};
